import { render, staticRenderFns } from "./BranchOrderServicer.vue?vue&type=template&id=76764ac6&"
import script from "./BranchOrderServicer.vue?vue&type=script&lang=ts&"
export * from "./BranchOrderServicer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports